
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Coupon</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Coupon</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="Coupon">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'CouponList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group " >
              <label class="control-label">Coupon Code</label>
              <input type="text" id="coupon_code" name="coupon_code"
                     
                     
                     v-model="value.coupon_code" class="form-control coupon_code"
                     placeholder="Coupon Code">
              
            </div>
            <div class="form-group required" >
              <label class="control-label">Discount Value</label>
              <input type="text" id="discount_value" name="discount_value"
                     v-bind:class="{'has-error' : errors.has('discount_value')}"
                     v-validate="'required'"
                     v-model="value.discount_value" class="form-control discount_value"
                     placeholder="Discount Value">
              <div class="help text-danger" v-show="errors.has('discount_value')">
                {{ errors.first("discount_value") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Discount Type</label>
              <select class="form-control" style="width: 100%;" v-bind:class="{'has-error' : errors.has('discount_type')}"
                      v-validate="'required'" name="discount_type" v-model="value.discount_type" id="discount_type">
                <option value="percentage">percentage</option><option value="flat">flat</option>
              </select>
              <div class="help text-danger" v-show="errors.has('discount_type')">
                {{ errors.first("discount_type") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Min Discount</label>
              <input type="text" id="min_discount" name="min_discount"
                     
                     
                     v-model="value.min_discount" class="form-control min_discount"
                     placeholder="Min Discount">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Max Discount</label>
              <input type="text" id="max_discount" name="max_discount"
                     
                     
                     v-model="value.max_discount" class="form-control max_discount"
                     placeholder="Max Discount">
              
            </div>
            <div class="form-group required" >
              <label class="control-label">Start Date</label>
              <div class="clearfix"></div>
              <date-picker type="date" input-class="form-control"
                v-bind:class="{'has-error' : errors.has('started_at')}"
                v-validate="'required'"
                name="started_at" v-model="value.started_at" lang="en"
                 format="YYYY-MM-DD" value-type="YYYY-MM-DD" placeholder="Start Date"></date-picker>
              <div class="help text-danger" v-show="errors.has('started_at')">
                {{ errors.first("started_at") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">End Date</label>
              <div class="clearfix"></div>
              <date-picker type="date" input-class="form-control"
                v-bind:class="{'has-error' : errors.has('ended_at')}"
                v-validate="'required'"
                name="ended_at" v-model="value.ended_at" lang="en"
                 format="YYYY-MM-DD" value-type="YYYY-MM-DD" placeholder="End Date"></date-picker>
              <div class="help text-danger" v-show="errors.has('ended_at')">
                {{ errors.first("ended_at") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Maximum Usage</label>
              <input type="text" id="max_usage" name="max_usage"
                     v-bind:class="{'has-error' : errors.has('max_usage')}"
                     v-validate="'required'"
                     v-model="value.max_usage" class="form-control max_usage"
                     placeholder="Maximum Usage">
              <div class="help text-danger" v-show="errors.has('max_usage')">
                {{ errors.first("max_usage") }}
              </div>
            </div>
                <div >
                    <h4 class="site-heading my-3"><span>Coupon_usages</span></h4>
                    <div class="form-row align-items-end" v-for="(coupon_usage, index) in value.coupon_usages">
                        
                    <div class="form-group col-md-11 required" >
                      <label class="control-label">User</label>
                      <input type="text" id="coupon_usage.user_id" name="coupon_usage.user_id"
                             v-bind:class="{'has-error' : errors.has('coupon_usage.user_id')}"
                             v-validate="'required'"
                             v-model="coupon_usage.user_id" class="form-control coupon_usage.user_id"
                             placeholder="User">
                      <div class="help text-danger" v-show="errors.has('coupon_usage.user_id')">
                        {{ errors.first("coupon_usage.user_id") }}
                      </div>
                    </div>
                    <div class="form-group col-md-11 required" >
                      <label class="control-label">Used</label>
                      <input type="text" id="coupon_usage.total_usage" name="coupon_usage.total_usage"
                             v-bind:class="{'has-error' : errors.has('coupon_usage.user_id')}"
                             v-validate="'required'"
                             v-model="coupon_usage.total_usage" class="form-control coupon_usage.total_usage"
                             placeholder="Used">
                      <div class="help text-danger" v-show="errors.has('coupon_usage.user_id')">
                        {{ errors.first("coupon_usage.user_id") }}
                      </div>
                    </div>
                        <div class="form-group col-md-1">
                            <button type="button" class="btn btn-danger float-right" @click="deleteCoupon_usage(index)"><i
                              class="fa fa-trash"></i>
                            </button>
                        </div>
                        
                    </div>
                    <button type="button" @click="addCoupon_usage" class="btn btn-success"><i
                      class="fa fa-plus"></i> New
                    </button>
                </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CouponForm",
  metaInfo: {
    title: "Coupon | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        coupon_usages: [],
        
    },
    pre: {
      
    }
  }),
  methods: {
    addCoupon_usage: function () {
      this.value.coupon_usages.push({});
    },
    
    deleteCoupon_usage: function (index) {
      this.value.coupon_usages.splice(index,1)
    },
    
    
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/coupons";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/coupons/" + _this.$route.params.id
            method = "PUT";
          }

          

          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CouponList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/coupons/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        
        
      }
      
      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

        